import { Eye, EyeOff } from "lucide-react";
import { useState } from "react";

export function AuthShell({ title, subtitle, children }) {
  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-12 bg-slate-50">
      <div className="hidden lg:flex lg:col-span-5 xl:col-span-6 bg-gradient-to-br from-[#0f2847] via-[#17416f] to-[#0a192f] text-white p-12 flex-col justify-between relative overflow-hidden">
        <div
          className="absolute inset-0 opacity-15 bg-cover bg-center"
          style={{
            backgroundImage:
              "url('https://images.pexels.com/photos/9159042/pexels-photo-9159042.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940')",
          }}
        />
        <div className="absolute -bottom-24 -right-24 w-72 h-72 rounded-full bg-[#f97316]/20 blur-3xl" />
        <div className="relative z-10">
          <div className="flex items-center gap-3">
            <div className="h-11 w-11 rounded-xl bg-[#f97316] grid place-items-center font-bold text-lg shadow-lg">
              IEC
            </div>
            <div>
              <p className="font-bold text-lg leading-tight">CRM IEC Mustikajaya</p>
              <p className="text-xs text-blue-200">Sistem Manajemen Calon Siswa</p>
            </div>
          </div>
        </div>
        <div className="relative z-10 space-y-4">
          <h2 className="text-3xl font-bold leading-snug">
            Membangun Masa Depan Pendidikan Berkualitas & Terpercaya
          </h2>
          <p className="text-blue-200 text-sm leading-relaxed max-w-md">
            Platform CRM untuk mengelola calon siswa dan lembaga di cabang IEC Mustikajaya,
            aman dan terpusat.
          </p>
        </div>
        <p className="relative z-10 text-xs text-blue-300">© 2026 IEC Mustikajaya · Zona Waktu WIB</p>
      </div>

      <div className="col-span-1 lg:col-span-7 xl:col-span-6 flex flex-col justify-center items-center p-6 sm:p-10 lg:p-16">
        <div className="w-full max-w-md">
          <div className="lg:hidden flex items-center gap-3 mb-8">
            <div className="h-10 w-10 rounded-xl bg-[#0f2847] grid place-items-center font-bold text-white">
              IEC
            </div>
            <p className="font-bold text-[#0f2847]">CRM IEC Mustikajaya</p>
          </div>
          <div className="mb-7">
            <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
            {subtitle && <p className="mt-2 text-sm text-slate-600 leading-relaxed">{subtitle}</p>}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}

export function Field({ label, error, children }) {
  return (
    <div className="space-y-1.5">
      <label className="text-xs font-semibold uppercase tracking-wider text-slate-500">{label}</label>
      {children}
      {error && <p className="text-xs text-red-600">{error}</p>}
    </div>
  );
}

const inputBase =
  "w-full px-3.5 py-2.5 bg-white border border-slate-300 rounded-lg text-slate-900 placeholder:text-slate-400 focus:border-[#0f2847] focus:ring-2 focus:ring-[#0f2847]/20 focus:outline-none transition-all duration-150 text-sm";

export function TextInput({ error, ...props }) {
  return <input className={`${inputBase} ${error ? "border-red-500" : ""}`} {...props} />;
}

export function PasswordInput({ error, testId, ...props }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        className={`${inputBase} pr-11 ${error ? "border-red-500" : ""}`}
        data-testid={testId}
        {...props}
      />
      <button
        type="button"
        onClick={() => setShow((s) => !s)}
        aria-label={show ? "Sembunyikan kata sandi" : "Tampilkan kata sandi"}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-700"
        data-testid={`${testId}-toggle`}
      >
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}

export const btnPrimary =
  "w-full bg-[#0f2847] hover:bg-[#17416f] text-white font-medium px-4 py-2.5 rounded-lg shadow-sm hover:shadow transition-colors duration-150 focus:ring-2 focus:ring-[#f97316] focus:outline-none disabled:opacity-50 flex items-center justify-center gap-2";
export const btnAccent =
  "w-full bg-[#f97316] hover:bg-[#ea580c] text-white font-medium px-4 py-2.5 rounded-lg shadow-sm hover:shadow transition-colors duration-150 focus:ring-2 focus:ring-[#0f2847] focus:outline-none disabled:opacity-50 flex items-center justify-center gap-2";
